import {RESULT_CONSTANT} from '../constants/ResultConst';

const initialState = {
  game_name: '',
  number: '',
  time: '',
  color: '',
  game_text_color: '',
};

const resultDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESULT_CONSTANT:
      return {
        ...state,
        resultDetail: action.payload,
      };
    default:
      return state;
  }
};
export default resultDetailReducer;
